import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a1ceadfe1784dbdcbe31219adbfb10601b from "./generated-aab0b26d-8cbf-4d35-8929-2366eb59a27c.json";

import aac1fcd7de6e7ff3342b84abfccb1c1bbb from "./generated-baa4ac3a-5a1f-4cfe-a581-b7545b26a26c.json";

import a96921ce1f5320a4e09053d47d242c1c5b from "./generated-05ef7549-2bc1-49c9-8a83-4106032db9ec.json";

import ad003162bae64926c188188cb0bacaa44b from "./generated-54317613-77ac-4034-93f6-1b895f0503ad.json";

import a7796d550df1bce14a1e0873de35ce909b from "./generated-4ac07dce-f007-4dfd-8633-b423ab663d43.json";

import a377ddeb987cf0abc0b66a5e74facc526b from "./generated-a3fbc03e-66cf-444d-b7fc-999de9482c56.json";

import a81d2492993c037c71a8c52b68a233344b from "./generated-fa9df63a-176f-44b3-9373-78949a5501df.json";

import a089d638029080de3b2b7e9c92cb5b7d5b from "./generated-e8cb43dc-406d-4930-8e59-d91e101a9fbb.json";

import ac93f566ed98d14f303a693e08c5ad4dab from "./generated-79684c44-4264-41ef-8519-99fb55cc591a.json";

import ae05466f6fcf3b9869a2dabc255a55cddb from "./generated-9f9fa68a-e858-4b70-b5da-21e0aa30e257.json";

import a84157562e10b3112f645012d814c4e62b from "./generated-7afeb2f7-1877-4fa0-a270-ae40cf494457.json";

import ad669bf7956e9c504b5b80c77ccb5c55ab from "./generated-6dacb073-4b66-4403-a26e-1107d1a1d4e4.json";

import a5402e75def9a975d6cac471c4a219920b from "./generated-bf0661f2-20c0-49f9-87d0-442546658888.json";

import a37514a40ab3dcb8cef2cb8c5a37c34c7b from "./generated-6a917045-3277-4015-9592-d56c4be406d3.json";

import a9263c492427f639e7e4676b7d98ed9afb from "./generated-4cd78305-6b81-4103-8bbc-bbd6118c67f9.json";

import a16af91b6b216273622ece8bf6de9906ab from "./generated-fb62338c-6df3-42eb-bc13-0ac2723d410b.json";

import a9262dd6afa70f4c4efb86250558e2df0b from "./generated-62209b8b-1754-441d-bdd4-1da2debbe513.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a1ceadfe1784dbdcbe31219adbfb10601b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(aac1fcd7de6e7ff3342b84abfccb1c1bbb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a96921ce1f5320a4e09053d47d242c1c5b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ad003162bae64926c188188cb0bacaa44b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a7796d550df1bce14a1e0873de35ce909b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a377ddeb987cf0abc0b66a5e74facc526b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a81d2492993c037c71a8c52b68a233344b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a089d638029080de3b2b7e9c92cb5b7d5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(ac93f566ed98d14f303a693e08c5ad4dab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ae05466f6fcf3b9869a2dabc255a55cddb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a84157562e10b3112f645012d814c4e62b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ad669bf7956e9c504b5b80c77ccb5c55ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(ac93f566ed98d14f303a693e08c5ad4dab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a5402e75def9a975d6cac471c4a219920b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a37514a40ab3dcb8cef2cb8c5a37c34c7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ac93f566ed98d14f303a693e08c5ad4dab);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a9263c492427f639e7e4676b7d98ed9afb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a16af91b6b216273622ece8bf6de9906ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a9262dd6afa70f4c4efb86250558e2df0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a9263c492427f639e7e4676b7d98ed9afb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */